import React, { useState, useEffect } from 'react';
import { mockGalleryData } from '../mock/mockData';
import { X } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = 'https://api.artwithsaloni.com';
// const BACKEND_URL = RAW_BACKEND_URL
//   ? (/^https?:\/\//i.test(RAW_BACKEND_URL) ? RAW_BACKEND_URL : `https://${RAW_BACKEND_URL}`).replace(/\/+$/, '')
//   : '';
const API = BACKEND_URL ? `${BACKEND_URL}/api` : '/api';

const Gallery = () => {
  const [selectedArt, setSelectedArt] = useState(null);
  const [filter, setFilter] = useState('All');
  const [artworks, setArtworks] = useState(mockGalleryData);
  const [loading, setLoading] = useState(true);
  const [useBackend, setUseBackend] = useState(false);

  useEffect(() => {
    fetchArtworks();
  }, []);

  const fetchArtworks = async () => {
    try {
      const response = await axios.get(`${API}/artworks/`);
      console.log(response.data);
      if (response.data && response.data.length > 0) {
        setArtworks(response.data);
        setUseBackend(true);
      }
    } catch (error) {
      console.log(error);
      console.log('Using mock data');
      setArtworks(mockGalleryData);
    } finally {
      setLoading(false);
    }
  };

  const categories = ['All', 'Folk Art', 'Landscape', 'Abstract'];

  const filteredArtwork = filter === 'All' 
    ? artworks 
    : artworks.filter(art => art.category === filter);

  // const getImageUrl = (artwork) => {
  //   const imagePath = artwork.imageUrl || artwork.image_url;
  //   console.log("IMAGE PATH:", imagePath);
  //   if (!imagePath) {
  //     return '';
  //   }

  //   if (/^https?:\/\//i.test(imagePath) || imagePath.startsWith('data:')) {
  //     return imagePath;
  //   }

  //   if (imagePath.startsWith('//')) {
  //     return `https:${imagePath}`;
  //   }

  //   if (!useBackend || !BACKEND_URL) {
  //     return imagePath;
  //   }

  //   return imagePath.startsWith('/')
  //     ? `${BACKEND_URL}${imagePath}`
  //     : `${BACKEND_URL}/${imagePath}`;
  // };

  const getImageUrl = (artwork) => {
    const imagePath = artwork.imageUrl || artwork.image_url || artwork.image;
    if (!imagePath) return "";
  
    if (/^https?:\/\//i.test(imagePath)) return imagePath;
  
    return imagePath.startsWith("/")
      ? `${BACKEND_URL}${imagePath}`
      : `${BACKEND_URL}/${imagePath}`;
  };

  return (
    <div style={{ backgroundColor: 'var(--color-white)', minHeight: '100vh' }}>
      {/* Header Section */}
      <section className="section-spacing" style={{ backgroundColor: 'var(--color-gray-100)' }}>
        <div className="container-artworld" style={{ textAlign: 'center' }}>
          <h1 className="section-title" style={{ marginBottom: 'var(--spacing-md)' }}>
            Art Gallery
          </h1>
          <p className="body-text" style={{ maxWidth: '600px', margin: '0 auto' }}>
            Explore my collection of original artwork, each piece created with passion and purpose
          </p>
        </div>
      </section>

      {/* Filter Section */}
      <section style={{ padding: 'var(--spacing-xl) 0', borderBottom: '1px solid var(--color-gray-200)' }}>
        <div className="container-artworld">
          <div style={{
            display: 'flex',
            gap: 'var(--spacing-md)',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setFilter(category)}
                style={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  padding: 'var(--spacing-sm) var(--spacing-lg)',
                  backgroundColor: filter === category ? 'var(--color-primary)' : 'transparent',
                  color: filter === category ? 'var(--color-white)' : 'var(--color-gray-700)',
                  border: `2px solid ${filter === category ? 'var(--color-primary)' : 'var(--color-gray-300)'}`,
                  cursor: 'pointer',
                  transition: 'all var(--transition-base)',
                  borderRadius: '4px'
                }}
                onMouseEnter={(e) => {
                  if (filter !== category) {
                    e.target.style.borderColor = 'var(--color-primary)';
                    e.target.style.color = 'var(--color-primary)';
                  }
                }}
                onMouseLeave={(e) => {
                  if (filter !== category) {
                    e.target.style.borderColor = 'var(--color-gray-300)';
                    e.target.style.color = 'var(--color-gray-700)';
                  }
                }}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="section-spacing-large">
        <div className="container-artworld">
          <div className="artist-grid">
            {loading ? (
              Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={index}
                  style={{
                    borderRadius: '8px',
                    overflow: 'hidden',
                    backgroundColor: 'var(--color-gray-100)',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
                  }}
                >
                  <div
                    style={{
                      aspectRatio: '1 / 1',
                      backgroundColor: '#e5e5e5'
                    }}
                  />

                  <div style={{ padding: 'var(--spacing-md)' }}>
                    <div
                      style={{
                        height: '20px',
                        backgroundColor: '#e5e5e5',
                        marginBottom: '10px',
                        borderRadius: '4px'
                      }}
                    />

                    <div
                      style={{
                        height: '14px',
                        width: '60%',
                        backgroundColor: '#e5e5e5',
                        borderRadius: '4px'
                      }}
                    />
                  </div>
                </div>
              ))
            ) : (
              filteredArtwork.map((art) => (
                <div
                  key={art.id}
                  className="image-overlay-container"
                  onClick={() => setSelectedArt(art)}
                  style={{
                    cursor: 'pointer',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    backgroundColor: 'var(--color-gray-100)',
                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                    transition: 'box-shadow var(--transition-base)'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0, 0, 0, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.08)';
                  }}
                >
                  <div style={{ aspectRatio: '1 / 1', overflow: 'hidden' }}>
                    <img
                      src={getImageUrl(art)}
                      alt={art.title}
                      loading="lazy"
                      decoding="async"
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        transition: 'transform var(--transition-slow)'
                      }}
                      onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
                      onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                    />
                  </div>
                  <div className="image-overlay" />
                  <div className="image-overlay-content">
                    <h3 className="artist-name" style={{ color: 'var(--color-white)', fontSize: '1.25rem', marginBottom: 'var(--spacing-xs)' }}>
                      {art.title}
                    </h3>
                    <p className="caption-text" style={{ color: 'var(--color-gray-200)' }}>
                      {art.medium}
                    </p>
                  </div>
                  <div style={{ padding: 'var(--spacing-md)' }}>
                    <div style={{ marginBottom: 'var(--spacing-xs)' }}>
                      <h3 className="body-text" style={{ fontWeight: '600', marginBottom: '4px' }}>{art.title}</h3>
                      <p className="caption-text" style={{ color: 'var(--color-gray-500)' }}>{art.dimensions}</p>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span className="type-indicator">{art.category}</span>
                      <span className="caption-text" style={{ 
                        color: art.available ? 'var(--color-gray-600)' : 'var(--color-gray-400)',
                        fontWeight: '600'
                      }}>
                        {art.available ? 'Available' : 'Sold'}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>

      {/* Modal for Artwork Details */}
      {selectedArt && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.9)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 'var(--spacing-lg)',
            animation: 'fadeIn 0.3s ease'
          }}
          onClick={() => setSelectedArt(null)}
        >
          <div
            style={{
              backgroundColor: 'var(--color-white)',
              maxWidth: '900px',
              width: '100%',
              maxHeight: '90vh',
              overflow: 'auto',
              borderRadius: '8px',
              position: 'relative'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setSelectedArt(null)}
              style={{
                position: 'absolute',
                top: 'var(--spacing-md)',
                right: 'var(--spacing-md)',
                background: 'var(--color-white)',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                zIndex: 10,
                transition: 'background-color var(--transition-base)'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--color-gray-100)'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'var(--color-white)'}
              aria-label="Close modal"
            >
              <X size={24} />
            </button>

            <img
              src={getImageUrl(selectedArt)}
              alt={selectedArt.title}
              loading="lazy"
              decoding="async"
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '60vh',
                objectFit: 'contain',
                backgroundColor: 'var(--color-gray-100)'
              }}
            />

            <div style={{ padding: 'var(--spacing-xl)' }}>
              <div style={{ marginBottom: 'var(--spacing-md)' }}>
                <span className="type-indicator">{selectedArt.category}</span>
              </div>
              <h2 className="section-title" style={{ marginBottom: 'var(--spacing-sm)' }}>
                {selectedArt.title}
              </h2>
              <p className="body-text" style={{ marginBottom: 'var(--spacing-lg)', fontSize: '1.125rem' }}>
                {selectedArt.description}
              </p>

              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: 'var(--spacing-md)',
                padding: 'var(--spacing-lg)',
                backgroundColor: 'var(--color-gray-100)',
                borderRadius: '8px',
                marginBottom: 'var(--spacing-lg)'
              }}>
                <div>
                  <p className="caption-text" style={{ marginBottom: 'var(--spacing-xs)' }}>Medium</p>
                  <p className="body-text" style={{ fontWeight: '600' }}>{selectedArt.medium}</p>
                </div>
                <div>
                  <p className="caption-text" style={{ marginBottom: 'var(--spacing-xs)' }}>Dimensions</p>
                  <p className="body-text" style={{ fontWeight: '600' }}>{selectedArt.dimensions}</p>
                </div>
                <div>
                  <p className="caption-text" style={{ marginBottom: 'var(--spacing-xs)' }}>Year</p>
                  <p className="body-text" style={{ fontWeight: '600' }}>{selectedArt.year}</p>
                </div>
                <div>
                  <p className="caption-text" style={{ marginBottom: 'var(--spacing-xs)' }}>Status</p>
                  <p className="body-text" style={{ 
                    fontWeight: '600',
                    color: selectedArt.available ? 'var(--color-primary)' : 'var(--color-gray-500)'
                  }}>
                    {selectedArt.available ? 'Available' : 'Sold'}
                  </p>
                </div>
              </div>

              {selectedArt.available && (
                <button className="btn-primary" style={{ width: '100%' }}>
                  Inquire About This Piece
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default Gallery;
